import { stateGo } from 'redux-ui-router';
import { map } from 'lodash';
import { anchorStorage } from 'utils';
import { selectHasWorkoutSubscription, selectMember } from 'logic/member';
import { fetchWorkoutVideos, selectWorkoutVideos } from 'logic/workout';

import {
  mapIsFavouriteVideos,
  selectFavouriteVideoIds,
  toggleFavouriteVideo,
} from 'logic/favourite';

import {
  selectSortByVideos,
  selectFiltersVideosGrouped,
  selectFiltersVideosChecked,
  toggleFiltersIsActive,
} from 'logic/filters';

export const WorkoutsVideos = {
  template: `
    <ui-view>
      <div class="py-3 py-md-4 bg-gray-100">
        <div class="container">
          <div class="row">
            <div class="col-md-3 pt-md-2">
              <nav-mobile-sidebar
                heading="Filter"
                is-active="$ctrl.filtersIsActive"
                on-click="$ctrl.toggleFiltersIsActive()">
                <search-filter-videos
                  filters="$ctrl.filters"
                  on-click="$ctrl.onUpdateParam(key, value)">
                </search-filter-videos>
              </nav-mobile-sidebar>
            </div>
            <div class="col-md-9">
              <div class="mobile-filter-row row d-flex d-md-none py-2 px-3 bg-white">
                <button class="btn btn-link p-0 d-inline-flex"
                  ng-click="$ctrl.toggleFiltersIsActive()">
                  <i class="fa fa-sliders"></i>
                  <span class="h6 text-green-dark mb-0">Filter</span>
                </button>
              </div>
              <search-filter-results
                query="$ctrl.search.params.q"
                filters="$ctrl.checkedFilters"
                on-clear-all="$ctrl.onClearAll()"
                on-update-param="$ctrl.onUpdateParam(key, value)"
                on-update-filter="$ctrl.onUpdateFilter(item)">
              </search-filter-results>
              <search-results
                on-update-param="$ctrl.onUpdateParam(key, value)"
                order="$ctrl.sortBy"
                pagination="$ctrl.pagination"
                type="workouts">
                <div class="row">
                  <div class="col-sm-6 pb-3"
                    ng-repeat="item in $ctrl.results track by $index">
                    <card-video
                      heading="item.title"
                      duration-in-mins="item.time"
                      image="item.thumbnailUrl.large"
                      is-favourite="item.isFavourite"
                      on-click="$ctrl.onClick(item)"
                      on-favourite="$ctrl.toggleFavouriteVideo({
                        memberId: $ctrl.member.id,
                        videoId: item.id,
                        isFavourite: item.isFavourite
                      })">
                    </card-video>
                  </div>
                </div>
              </search-results>
            </div>
          </div>
        </div>
      </div>
    </ui-view>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.videos) {
          this.fetchWorkoutVideos(this.params);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      onClick({ id, title }) {
        if (this.hasAccess) {
          this.stateGo('workouts.videos.detail', { videoId: id });
          anchorStorage.set($ngRedux.getState(), title);
        }
      },

      onClearAll() {
        this.stateGo('workouts.videos', {
          type: undefined,
          equipmentRequired: undefined,
          time: undefined,
        });
      },

      onUpdateFilter(item) {
        const { [item.key]: undefined, ...params } = this.params;
        const { type, equipmentRequired, time } = params;

        this.stateGo('workouts.videos', { type, equipmentRequired, time });
      },

      onUpdateParam(key, value = '') {
        this.stateGo('workouts.videos', {
          ...this.params,
          [key]: value,
        });
      },

      mapState({ favourite, filters, member, router, workout }) {
        const params = router.currentParams;
        const { order, page } = params;
        const pagination = selectWorkoutVideos(workout, page);

        return {
          page,
          pagination,
          params,
          filters: selectFiltersVideosGrouped(filters, params),
          filtersIsActive: filters.isActive,
          checkedFilters: selectFiltersVideosChecked(filters, params),
          hasAccess: selectHasWorkoutSubscription(member),
          isLoading: workout.isLoading,
          member: selectMember(member),
          results: mapIsFavouriteVideos(
            pagination.result,
            selectFavouriteVideoIds(favourite)
          ),
          sortBy: selectSortByVideos(filters, order),
        };
      },

      mapDispatch() {
        return {
          fetchWorkoutVideos,
          stateGo,
          toggleFavouriteVideo,
          toggleFiltersIsActive,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Videos.js